import { BookOpen, Languages } from 'lucide-react'
import { cn } from '@/utils/cn'
import { useTranslation } from 'react-i18next'

export type SurahTab = 'reading' | 'translation' | 'mushaf' | 'audio'

interface SurahTabsProps {
  activeTab: SurahTab
  onTabChange: (tab: SurahTab) => void
}

export default function SurahTabs({ activeTab, onTabChange }: SurahTabsProps) {
  const { t } = useTranslation()

  const tabs = [
    { id: 'reading' as SurahTab, label: t('quran.tabs.reading', 'القراءة'), icon: BookOpen },
    { id: 'translation' as SurahTab, label: t('quran.tabs.translation', 'الترجمة'), icon: Languages },
  ]

  return (
    <div className="flex gap-2 border-b border-gray-200 dark:border-gray-700 mb-6">
      {tabs.map((tab) => {
        const Icon = tab.icon
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex items-center gap-2 px-4 py-3 font-medium transition-colors border-b-2 -mb-px',
              activeTab === tab.id
                ? 'text-primary-600 dark:text-primary-400 border-primary-600 dark:border-primary-400'
                : 'text-gray-600 dark:text-gray-400 border-transparent hover:text-primary-600 dark:hover:text-primary-400 hover:border-gray-300 dark:hover:border-gray-600'
            )}
          >
            <Icon className="w-4 h-4" />
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}


